import { $util, $event_publisher } from "@util/util.js";
import ActionTool from "@core/ActionTool.js";
import Constant from "@constant/index.js";

export default class Price{
    constructor(engine){
        this._total = '';
        this._totalPrefix = '';
        this._totalSuffix = '';
        this._discount = '';
        this._isChecked = false;
        this._parent = engine;
        this._totalCheckedCount = 0;
        this._totalCount = 0;
        this._totalCheckedCountStr = 0;
        this.isShowDiscountDetails = false;
        this.deliveryPriceInfo = null;
    }

    init(data){
        this.checkedAll = data?.checkedAll || false;
        this._total = data?.deliveryPriceInfo?.deliverPrice?.price || data?.afterDiscount?.showAmount || '';
        this._discount = '¥'+(data?.deliveryPriceInfo?.preferentialPrice?.price || data?.totalDiscount?.showAmount || '');
        this._totalCheckedCount = data.totalNumChecked;
        this._purchaseEnableNum = data.purchaseEnableNum;
        this._invalidNum = data.invalidNum;
        this._totalCount = data.totalNum;
        this._totalCheckedCountStr = data.totalNumChecked>99?"99+":data.totalNumChecked;
        this.isShowDiscountDetails = (data?.deliveryPriceInfo?.preferentialPrice?.price || data.totalDiscount.showAmount) > 0;
        this.deliveryPriceInfo = data.deliveryPriceInfo;
        if(_engine._editStatus != undefined && _engine._editStatus == true){
            //编辑状态判断是否全选，接口返回的选中的总数+不可购买商品的选中总数 == 购物车总数-失效商品数
            if(this._totalCheckedCount != 0  && (this._totalCheckedCount + _engine._editSelectedDisablePurchaseGoodsNum == this._totalCount - this._invalidNum) ){
                this._isChecked = true;
            }else{
                this._isChecked = false;
            }
        }else{
            if(this._totalCheckedCount == this._purchaseEnableNum && this._totalCheckedCount != 0){
                this._isChecked = true;
            }else{
                this._isChecked = false;
            }
        }
        // this._isChecked_fake = this._isChecked;

        if(this._total.indexOf('.') != -1){
            this._totalPrefix = '¥'+this._total.split('.')[0];
            this._totalSuffix = '.'+this._total.split('.')[1];
        }else{
            this._totalPrefix = '¥'+this._total;
            this._totalSuffix = "";
        }
    }

    //激活状态
    batchSetActive(){
        //获取所有MainSku的itemId，套餐的itemId挂载在主品上面，因此无需单独处理套餐的选中状态
        let actionItems = $util.getPurchaseEnabledMainSkus(this._parent._group);
        let ids = [];
        actionItems.forEach(x=>{
            ids.push(x.itemId);
        })
        return new Promise((resolve, reject)=>{
            if(ids.length>0){
                ActionTool.setActive({model:this, itemIds:ids.join('@')}).then(data=>{
                    //价格变动
                    $event_publisher.broadcast(Constant.EVENT_KEY.PRICE, data);
                    // //重新设置所有MainSku和package group的isChecked属性
                    // $event_publisher.broadcast(Constant.EVENT_KEY.CHANGE_ALL_ACTIVE, data);
                    //重新渲染购物车
                    $event_publisher.broadcast(Constant.EVENT_KEY.RERENDER_CART, data);
                    resolve();
                }).catch(err=>{
                    reject(err);
                })
            }else{
                if(_engine._editSelectedDisablePurchaseGoodsNum != undefined){
                    if( _engine._editSelectedDisablePurchaseGoodsNum == 0){
                        reject("没有可选的商品");
                    }
                }else{
                    reject("没有可选的商品");
                }                
            }
        })
    }

    //批量删除 & 清空失效商品
    batchRemove(actionItems){
        let ids = [];
        actionItems.forEach(x=>{
            ids.push(x._itemId);
        })

        return new Promise((reslove,reject)=>{
            ActionTool.removeAction({model:this, itemIds:ids.join('@')}).then(data=>{
                //删除后购物车没有商品了，就退出编辑状态
                if(data && data.num ==0 && _engine._editStatus ){
                    _engine._editStatus = false;  
                    $event_publisher.broadcast(Constant.EVENT_KEY.RERENDER_CART, data); 
                    //价格变动
                    $event_publisher.broadcast(Constant.EVENT_KEY.PRICE, data);
                }else{
                    //价格变动
                    $event_publisher.broadcast(Constant.EVENT_KEY.PRICE, data);
                    //删除主品, package也会删掉
                    actionItems.forEach(sku => {
                        $event_publisher.broadcast(Constant.EVENT_KEY.REMOVE_MAINSKU, sku);
                    });
                }
                reslove();
            }).catch(err=>{
                reject(err);
            })
        });
    }
    
    //批量加入收藏夹
    batchToFavorite(actionItems){        
        let ids = [];
        actionItems.forEach(x=>{
            ids.push(x._id);
        })
        return ActionTool.addFavorite(ids.join(',')).then(data=>{
            return this.batchRemove(actionItems);
        }).catch(err=>{
            return Promise.reject(err);
        })
    }
}